<template>
  <div>
    <div v-if="showEdit">
      <v-card>
        <ApproveReceiptEdit
          :alldata="items"
          :readonly="!['admin', 'superadmin'].includes($store.state.privilege.role)"
          :editdata="editdata"
          v-if="!loading"
          @onsave="onsave"
          @close="showEdit = false"
        ></ApproveReceiptEdit>
      </v-card>
    </div>
    <div v-else>
      <div class="mb-3">
        <v-btn :loading="loading" @click="handleShowExportList('exportxlsx')" color="grey" outline>
          <em class="fas fa-file-export" />
          &nbsp;
          {{ $t('export') }}&nbsp;
        </v-btn>
        <v-btn
          :loading="loading"
          @click="handleShowExportList('exportxlsxReceipt')"
          color="grey"
          outline
        >
          <em class="fas fa-file-export" />
          &nbsp;
          {{ $t('การตรวจใบเสร็จ') }}&nbsp;
        </v-btn>
        <v-btn
          :loading="loading"
          @click="handleShowExportList('exportxlsxProducts')"
          color="grey"
          outline
        >
          <em class="fas fa-file-export" />
          &nbsp;
          {{ $t('ข้อมูลการซื้อ') }}&nbsp;
        </v-btn>
      </div>

      <div class="mb-2">
        <date-filter
          @changeDate="onChangeDate"
          :defaultFilter="'last_month'"
          v-model="selectedDate"
        ></date-filter>
      </div>
      <v-layout row wrap class="pa-0 ma-0 mb-3">
        <v-flex xs4>
          <div>
            <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>search</v-btn>
          </div>
        </v-flex>
        <v-flex xs8>
          <div class="text-xs-right">
            <span v-for="(item, k) in statusbuttons" :key="k">
              <v-btn v-if="item == status" depressed color="primary" style="border-radius: 4px">{{
                item
              }}</v-btn>
              <v-btn
                v-else
                @click="
                  status = item
                  onChangeDate()
                "
                color="grey"
                outline
                style="border-radius: 4px"
                >{{ item }}</v-btn
              >
            </span>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs5>
          <div v-if="showCheckBox" style="display: flex">
            <div style="align-self: center" class="mr-3">
              <v-checkbox
                color="primary"
                class="ma-0 pa-0"
                hide-details
                label="Select all"
                v-model="selectAll"
              ></v-checkbox>
            </div>
            <div>
              <v-btn
                @click="approveall"
                :loading="approveloading"
                :disabled="!selectedItems.length"
                depressed
                color="primary"
                >Approve selected</v-btn
              >
            </div>
          </div>
        </v-flex>
      </v-layout>
      <pagination
        v-model="pageNumber"
        :limit="limit"
        :total="total"
        :key="timestamp"
        @onChange="handleChangePage"
      >
        <div>
          <div v-if="loading" class="text-xs-center">
            <scale-loader class="my-4" :loading="true" color="grey"></scale-loader>
          </div>
          <div v-else>
            <div v-if="total == 0">
              <div style="font-size: 22px" class="mt-4 grey--text text-xs-center">ไม่พบข้อมูล</div>
            </div>
            <div v-else>
              <v-card
                v-for="(item, k) in items"
                :key="k"
                class="pa-2 mb-3 pb-3"
                style="border-radius: 5px; border: 3px solid #1548a7; position: relative"
              >
                <v-checkbox
                  v-if="showCheckBox"
                  style="position: absolute; left: 0px; top: 0px; margin-top: 0px"
                  color="primary"
                  v-model="selectedItems"
                  :value="item.id"
                ></v-checkbox>
                <div class="red--text" v-if="item.status == 'reject'" style="font-size: 13px">
                  Rejected by Admin
                  <span
                    @click="showReason(item, true)"
                    style="text-decoration: underline; cursor: pointer"
                    >ดูสาเหตุ</span
                  >
                </div>
                <div class="red--text" v-if="getRejectedBy(item)" style="font-size: 13px">
                  Rejected by {{ getRejectedBy(item) }}
                  <span
                    @click="showReason(item)"
                    style="text-decoration: underline; cursor: pointer"
                    >ดูสาเหตุ</span
                  >
                </div>
                <div>
                  <v-layout row wrap class="pa-0 ma-0 px-4">
                    <v-flex xs4 class="pt-3" style="font-size: 16px">
                      <div><span>ชื่อลูกค้า : </span>{{ item.customer_name }}</div>
                      <div>
                        <span class="grey--text">ห้าง : </span>{{ item.department_store || '-' }}
                        <span class="grey--text">สาขา : </span>{{ item.branch || '-' }}
                      </div>
                      <div class="caption">
                        {{ item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
                      </div>
                    </v-flex>
                    <v-flex xs4 class="pt-5">
                      <div>เลขที่ใบเสร็จ: {{ item.ref_no ? item.ref_no : '-' }}</div>
                      <div>
                        คะแนนที่ได้: {{ item.total_points === null ? '-' : item.total_points }}
                      </div>
                    </v-flex>
                    <v-flex xs4>
                      <div style="display: flex; justify-content: flex-end" class="text-xs-right">
                        <div class="mr-2" style="align-self: center">Admin</div>
                        <div>
                          <v-chip
                            class="px-2"
                            label
                            small
                            dark
                            :color="statusCustom(item.status).color"
                            >{{ statusCustom(item.status).text }}</v-chip
                          >
                        </div>
                        <div class="mx-2" style="align-self: center">Manager</div>
                        <div>
                          <v-chip
                            class="px-2"
                            label
                            small
                            dark
                            :color="statusCustom(item.manager_status).color"
                            >{{ statusCustom(item.manager_status).text }}</v-chip
                          >
                        </div>
                        <div class="mx-2" style="align-self: center">Accounting</div>
                        <div>
                          <v-chip
                            class="px-2"
                            label
                            small
                            dark
                            :color="statusCustom(item.accounting_status).color"
                            >{{ statusCustom(item.accounting_status).text }}</v-chip
                          >
                        </div>
                      </div>
                      <div class="text-xs-right">
                        <v-btn
                          @click="showAdminEdit(item)"
                          class="px-5"
                          color="primary"
                          depressed
                          >{{
                            ['admin', 'superadmin'].includes($store.state.privilege.role)
                              ? 'กรอกข้อมูล'
                              : 'ดูข้อมูล'
                          }}</v-btn
                        >
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card>
            </div>
          </div>
        </div>
      </pagination>
    </div>

    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn @click="showsearch = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('ชื่อลูกค้า') }}</label>
                <input v-model="filter.customer_name" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('เลขใบเสร็จ') }}</label>
                <input v-model="filter.ref_no" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('ห้าง') }}</label>
                <multiselect
                  placeholder="เลือกห้าง"
                  :show-labels="false"
                  v-model="filter.department_store"
                  :options="departmentOptions"
                ></multiselect>
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('สาขา') }}</label>
                <multiselect
                  placeholder="เลือกสาขา"
                  :show-labels="false"
                  v-model="filter.branch"
                  :options="branchOptions"
                ></multiselect>
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn @click="clearsearch" outline color="grey">Clear</v-btn>
            <v-btn @click="onsearch" color="primary">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <div>
      <v-dialog v-model="showReasonDialog" persistent width="500px">
        <v-card v-if="showReasonDialog" class="px-5 pt-3 pb-3">
          <div class="text-xs-center" style="font-size: 18px; font-weight: bold; color: red">
            สาเหตุที่ Reject
          </div>
          <div class="mt-4" style="font-size: 16px">{{ currentreason }}</div>
          <div class="text-xs-center mt-3">
            <v-btn color="grey" outline @click="showReasonDialog = false">ปิด</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>

    <template v-if="showExportList">
      <ExportList
        v-model="showExportList"
        :exportpagecount="exportpagecount"
        :exportlimit="exportlimit"
        :total="total"
        @handleExportByPage="handleExportByPage"
      />
    </template>
  </div>
</template>

<script>
import api from '@/api'
import importxlsx from '@/components/elements/importxlsx.vue'
// import exportxlsx from '@/components/elements/exportxlsx.vue'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import XLSX from 'xlsx'
import ApproveReceiptEdit from './ApproveReceiptEdit.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import moment from 'moment'
import Pagination from '@/components/elements/Pagination2.vue'
import ExportList from './ExportList.vue'

export default {
  components: {
    DateFilter,
    importxlsx,
    Multiselect,
    ApproveReceiptEdit,
    ScaleLoader,
    Pagination,
    ExportList
  },
  data() {
    return {
      branchOptions: [],
      departmentOptions: [],
      selectedItems: [],
      currentreason: '',
      statusbuttons: ['all', 'pending', 'approved', 'reject'],
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      importloading: false,
      showEdit: false,
      approveloading: false,
      editdata: '',

      columnName: '',
      items: [],
      status: 'all',
      filter: {
        ref_no: '',
        customer_name: '',
        department_store: '',
        branch: ''
      },
      exportloading: false,
      showsearch: false,
      showReasonDialog: false,
      loading: true,

      pageNumber: 1,
      timestamp: moment().format('x'),
      showExportList: false,
      currentExport: null, // exportxlsx , exportxlsxReceipt , exportxlsxProducts
      exportlimit: 1000,
      exportpagecount: 0
    }
  },
  computed: {
    purchase_amount() {
      if (this.$store.state.toacrmpointdata && this.$store.state.toacrmpointdata.purchase_amount) {
        return Math.floor(parseFloat(this.$store.state.toacrmpointdata.purchase_amount))
      } else return 0
    },
    exportDataReceipt() {
      return this.items.map((el) => {
        if (el.details && el.details.products) {
          var sumprice = this.sumPrice(el.details.products)
          var points_by_purchase = this.points_by_purchase(el.details.products)
          var points_by_product = this.points_by_product(el.details.products)
        } else {
          var sumprice = 0
          var points_by_purchase = 0
          var points_by_product = 0
        }

        var sumpoint = points_by_purchase + points_by_product
        // console.log(JSON.stringify(el.ref_no_image).join(','))
        return {
          เลขบัตรประชาชน: el.identity_number,
          ชื่อลูกค้า: el.first_name + '  ' + el.last_name,
          เบอร์โทรศัพท์: el.phone_number,
          วันที่อัพโหลดบิล: moment(el.timestamp).format('DD/MM/YYYY'),
          วันที่ซื้อในใบเสร็จ: el.details ? moment(el.details.date).format('DD/MM/YYYY') : '',
          เลขที่ใบเสร็จ: el.details && el.details.ref_no ? el.details.ref_no : el.ref_no,
          ยอดซื้อรวม: sumprice,
          คะแนนที่ได้: sumpoint,
          ห้าง: el.department_store,
          สาขา: el.branch,
          'ผู้ตรวจบิล (Admin)': el.admin,
          'วันที่ตรวจ (Admin)':
            el.verified_receipt_timestamp &&
            moment(el.verified_receipt_timestamp).format('DD/MM/YYYY'),
          'ผู้จัดการอนุมัติ (Manager)': el.manager,
          'วันที่ตรวจ (Manager)':
            el.manager_receipt_timestamp &&
            moment(el.manager_receipt_timestamp).format('DD/MM/YYYY'),
          'บัญชีผู้อนุมัติ (Accounting)': el.accounting,
          'วันที่ตรวจ (Accounting)':
            el.accounting_receipt_timestamp &&
            moment(el.accounting_receipt_timestamp).format('DD/MM/YYYY'),
          ที่อยู่รูปภาพใบเสร็จ: JSON.parse(el.ref_no_image).join(',')
        }
      })
    },
    showCheckBox() {
      return !['admin', 'superadmin'].includes(this.$store.state.privilege.role)
    },
    selectAll: {
      get: function () {
        if (this.items.length) {
          return this.items ? this.selectedItems.length == this.items.length : false
        } else return false
      },
      set: function (value) {
        var selected = []

        if (value) {
          this.items.forEach(function (item) {
            selected.push(item.id)
          })
        }

        this.selectedItems = selected
      }
    },
    filteredItems() {
      var result = [...this.items]
      const start = (this.pageNumber - 1) * this.limit
      const end = start + this.limit
      return result.slice(start, end)
      // return result
    },
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    this.loading = true
    Promise.all([this.getProduct(), this.getBranch(), this.getPointData()])
    await this.getData()
    this.loading = false
  },
  methods: {
    handleExportByPage(page) {
      switch (this.currentExport) {
        case 'exportxlsx':
          this.exportxlsx(page)
          break
        case 'exportxlsxReceipt':
          this.exportxlsxReceipt(page)
          break
        case 'exportxlsxProducts':
          this.exportxlsxProducts(page)
          break

        default:
          break
      }
      this.showExportList = false
    },
    handleShowExportList(type) {
      this.currentExport = type
      this.exportpagecount = Math.ceil(this.total / this.exportlimit)
      this.showExportList = true
    },
    async handleChangePage(val) {
      const { offset } = val
      this.offset = offset
      this.pageNumber = 1
      this.timestamp = moment().format('x')
      await this.getData()
    },
    points_by_product(products) {
      var result
      result = products.reduce((acc, cur) => {
        return (
          acc + (cur.name ? parseFloat(cur.name.points || 0) : 0) * parseFloat(cur.quantity || 0)
        )
      }, 0)
      return Math.floor(result)
    },
    points_by_purchase(products) {
      var result = 0
      var sum = products.reduce((acc, cur) => {
        return acc + parseFloat(cur.price || 0) * parseFloat(cur.quantity || 0)
      }, 0)
      result = sum / this.purchase_amount
      return Math.floor(result)
    },
    sumPrice(products) {
      return Math.floor(
        parseFloat(
          products.reduce((acc, cur) => {
            return acc + parseFloat(cur.price || 0) * parseFloat(cur.quantity)
          }, 0)
        )
      )
    },
    getRejectedBy(item) {
      if (item.manager_remark || item.accounting_remark) {
        return item.manager_remark ? 'Manager' : 'Accounting'
      } else {
        return false
      }
    },
    async approveall() {
      this.$swal
        .fire({
          text: 'ยืนยันการ Approve ?',
          showCancelButton: true
        })
        .then(async (result) => {
          if (result.value) {
            this.approveloading = true
            if (this.$store.state.privilege.role == 'manager') {
              await this.managerSave()
            } else if (this.$store.state.privilege.role == 'accounting') {
              await this.accountingSave()
            }
            this.approveloading = false
            this.selectedItems = []
            await this.getData()
          }
        })
    },

    showReason(item, isAdmin = false) {
      if (isAdmin) {
        this.currentreason = item.remark
        this.showReasonDialog = true
      } else {
        this.currentreason = item.manager_remark || item.accounting_remark
        this.showReasonDialog = true
      }
    },
    onChangeDate() {
      try {
        this.offset = 0
        this.pageNumber = 1
        this.timestamp = moment().format('x')
        this.getData()
      } catch (error) {
        console.error(error)
      }
    },
    statusCustom(status) {
      if (status == 'none') {
        return { text: 'None', color: 'grey' }
      } else if (status == 'pending') {
        return { text: 'Pending', color: 'orange' }
      } else if (status == 'approved') {
        return { text: 'Approved', color: 'green' }
      } else if (status == 'reject') {
        return { text: 'Reject', color: 'red' }
      } else return { text: status, color: 'primary' }
    },
    getData() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid, // required
          tab: this.$store.state.privilege.role, // required ** admin, manager, accounting **
          start_time: this.selectedDate.start
            ? moment(this.selectedDate.start).format('YYYY-MM-DD')
            : undefined, // YYYY-MM-DD
          end_time: this.selectedDate.end
            ? moment(this.selectedDate.end).format('YYYY-MM-DD')
            : undefined, // YYYY-MM-DD
          status: this.status, // all, pending, approved, reject
          limit: this.limit,
          offset: this.offset
        }
        for (const key in this.filter) {
          if (this.filter[key]) {
            Object.assign(data, { [key]: this.filter[key] })
          }
        }
        this.loading = true
        api.getapprovereceipttoacrm(data, (err, response) => {
          this.loading = false
          if (response.responsecode == 200) {
            this.items = response.data
            this.total = response.total
          }
        })
      })
    },
    getPointData() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid
        }
        api.getpointdatatoacrm(data, (err, response) => {
          if (response.responsecode == 200) {
            this.$store.state.toacrmpointdata = response.data[0]
          }
        })
        resolve()
      })
    },
    getBranch() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid
        }

        api.gettoacrmBranch(data, (err, response) => {
          this.branchOptions = [...new Set(response.data.map((el) => el.branch))]
          this.departmentOptions = [...new Set(response.data.map((el) => el.department_store))]
          this.$store.state.toacrmbranch = response.data

          resolve()
        })
      })
    },
    getProduct() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid
        }
        api.getproducttoacrm(data, (err, response) => {
          this.$store.state.toacrmproducts = response.data
          resolve()
        })
      })
    },

    clearsearch() {
      this.filter = {
        ref_no: '',
        customer_name: '',
        department_store: '',
        branch: ''
      }
      try {
        this.offset = 0
        this.pageNumber = 1
        this.timestamp = moment().format('x')
        this.getData()
      } catch (error) {
        console.error(error)
      }
      this.showsearch = false
    },
    onsearch() {
      try {
        this.offset = 0
        this.pageNumber = 1
        this.timestamp = moment().format('x')
        this.getData()
      } catch (error) {
        console.error(error)
      }
      this.showsearch = false
    },
    async exportxlsx(page) {
      this.loading = true

      var data = {
        pageid: this.selectedBot.pageid, // required
        tab: this.$store.state.privilege.role, // required ** admin, manager, accounting **

        start_time: this.selectedDate.start
          ? moment(this.selectedDate.start).format('YYYY-MM-DD')
          : undefined, // YYYY-MM-DD
        end_time: this.selectedDate.end
          ? moment(this.selectedDate.end).format('YYYY-MM-DD')
          : undefined, // YYYY-MM-DD
        status: this.status,

        limit: this.exportlimit,
        offset: (page - 1) * this.exportlimit
      }
      this.loading = true
      api.getapprovereceipttoacrm(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          var exporteddata = response.data

          var json = exporteddata.map((val) => {
            var total_price = 0
            if (val.details) {
              total_price = val.details.products.reduce((a, b) => {
                return a + parseFloat(b.price) * parseInt(b.quantity)
              }, 0)
            }
            return {
              รหัสบัตรประชาชน: val.identity_number,
              ชื่อลูกค้า: val.customer_name,
              วันที่อัพโหลดบิล: moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
              วันที่ซื้อในใบเสร็จ: val.details ? val.details.date : '',
              เลขที่ใบเสร็จ: val.details ? val.details.ref_no : '',
              ยอดซื้อรวม: total_price,
              คะแนนที่ได้: val.total_points
            }
          })

          const dataWS = XLSX.utils.json_to_sheet(json)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, 'exportedReceiptData' + '.xlsx')
          this.loading = false
        }
      })
    },
    async exportxlsxReceipt(page) {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid, // required
        tab: this.$store.state.privilege.role, // required ** admin, manager, accounting **

        start_time: this.selectedDate.start
          ? moment(this.selectedDate.start).format('YYYY-MM-DD')
          : undefined, // YYYY-MM-DD
        end_time: this.selectedDate.end
          ? moment(this.selectedDate.end).format('YYYY-MM-DD')
          : undefined, // YYYY-MM-DD
        status: this.status,

        limit: this.exportlimit,
        offset: (page - 1) * this.exportlimit
      }
      api.getapprovereceipttoacrm(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          var exporteddata = response.data
          var json = exporteddata.map((el) => {
            if (el.details && el.details.products) {
              var sumprice = this.sumPrice(el.details.products)
              var points_by_purchase = this.points_by_purchase(el.details.products)
              var points_by_product = this.points_by_product(el.details.products)
            } else {
              var sumprice = 0
              var points_by_purchase = 0
              var points_by_product = 0
            }

            var sumpoint = points_by_purchase + points_by_product
            // console.log(JSON.stringify(el.ref_no_image).join(','))
            return {
              เลขบัตรประชาชน: el.identity_number,
              ชื่อลูกค้า: el.first_name + '  ' + el.last_name,
              เบอร์โทรศัพท์: el.phone_number,
              วันที่อัพโหลดบิล: moment(el.timestamp).format('DD/MM/YYYY'),
              วันที่ซื้อในใบเสร็จ: el.details ? moment(el.details.date).format('DD/MM/YYYY') : '',
              เลขที่ใบเสร็จ: el.details && el.details.ref_no ? el.details.ref_no : el.ref_no,
              ยอดซื้อรวม: sumprice,
              คะแนนที่ได้: sumpoint,
              ห้าง: el.department_store,
              สาขา: el.branch,
              'ผู้ตรวจบิล (Admin)': el.admin,
              'วันที่ตรวจ (Admin)':
                el.verified_receipt_timestamp &&
                moment(el.verified_receipt_timestamp).format('DD/MM/YYYY'),
              'ผู้จัดการอนุมัติ (Manager)': el.manager,
              'วันที่ตรวจ (Manager)':
                el.manager_receipt_timestamp &&
                moment(el.manager_receipt_timestamp).format('DD/MM/YYYY'),
              'บัญชีผู้อนุมัติ (Accounting)': el.accounting,
              'วันที่ตรวจ (Accounting)':
                el.accounting_receipt_timestamp &&
                moment(el.accounting_receipt_timestamp).format('DD/MM/YYYY'),
              ที่อยู่รูปภาพใบเสร็จ: JSON.parse(el.ref_no_image).join(',')
            }
          })
          const dataWS = XLSX.utils.json_to_sheet(json)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, 'exportedReceiptData' + '.xlsx')
          this.loading = false
        }
      })
    },
    async exportxlsxProducts(page) {
      this.loading = true
      var json = []

      var row = {
        start: 1,
        end: 0
      }

      var merge = []

      var data = {
        pageid: this.selectedBot.pageid, // required
        tab: this.$store.state.privilege.role, // required ** admin, manager, accounting **

        start_time: this.selectedDate.start
          ? moment(this.selectedDate.start).format('YYYY-MM-DD')
          : undefined, // YYYY-MM-DD
        end_time: this.selectedDate.end
          ? moment(this.selectedDate.end).format('YYYY-MM-DD')
          : undefined, // YYYY-MM-DD
        status: this.status,

        limit: this.exportlimit,
        offset: (page - 1) * this.exportlimit
      }
      api.getapprovereceipttoacrm(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          var exporteddata = response.data
          exporteddata.forEach((el, k) => {
            if (k) {
              row.start = row.end + 1
            }
            if (el.details && el.details.products.length) {
              row.end += el.details.products.length
              var points_by_product = this.points_by_product(el.details.products)
              el.details.products.forEach((product) => {
                json.push({
                  ชื่อลูกค้า: el.first_name + ' ' + el.last_name,
                  เบอร์โทรศัพท์: el.phone_number,
                  อาชีพ: el.job,
                  ห้าง: el.department_store,
                  สาขา: el.branch,
                  เลขที่ใบเสร็จ: el.details && el.details.ref_no ? el.details.ref_no : el.ref_no,
                  'Ref.': el.details ? el.details.ref : '',
                  วันที่ซื้อ: el.details ? moment(el.details.date).format('DD/MM/YYYY') : '',
                  SKU: product.name && product.name.sku ? product.name.sku : '',
                  รายการสินค้า:
                    product.name && product.name.product_name ? product.name.product_name : '',
                  ราคา: product.price,
                  จำนวน: product.quantity,
                  ราคารวม:
                    product.price && product.quantity
                      ? parseFloat(product.price) * parseFloat(product.quantity)
                      : 0,
                  'ผู้ตรวจ (Admin)': el.admin,
                  วันที่ตรวจ: el.verified_receipt_timestamp
                    ? moment(el.verified_receipt_timestamp).format('DD/MM/YYYY')
                    : '',
                  คะแนนที่ได้จากบิลนี้: points_by_product
                })
              })
            } else {
              row.end++
              json.push({
                ชื่อลูกค้า: el.first_name + ' ' + el.last_name,
                เบอร์โทรศัพท์: el.phone_number,
                อาชีพ: el.job,
                ห้าง: el.department_store,
                สาขา: el.branch,
                เลขที่ใบเสร็จ: el.details && el.details.ref_no ? el.details.ref_no : el.ref_no,
                'Ref.': el.details ? el.details.ref : '',
                วันที่ซื้อ: el.details ? moment(el.details.date).format('DD/MM/YYYY') : '',
                SKU: '',
                รายการสินค้า: '',
                ราคา: '',
                จำนวน: '',
                ราคารวม: '',
                'ผู้ตรวจ (Admin)': '',
                วันที่ตรวจ: '',
                คะแนนที่ได้จากบิลนี้: ''
              })
            }
            merge.push(
              { s: { r: row.start, c: 0 }, e: { r: row.end, c: 0 } }, //ชื่อลูกค้า
              { s: { r: row.start, c: 1 }, e: { r: row.end, c: 1 } }, //เบอร์โทรศัพท์
              { s: { r: row.start, c: 2 }, e: { r: row.end, c: 2 } }, //อาชีพ
              { s: { r: row.start, c: 3 }, e: { r: row.end, c: 3 } }, //ห้าง
              { s: { r: row.start, c: 4 }, e: { r: row.end, c: 4 } }, //สาขา
              { s: { r: row.start, c: 5 }, e: { r: row.end, c: 5 } }, //เลขที่ใบเสร็จ
              { s: { r: row.start, c: 6 }, e: { r: row.end, c: 6 } }, //Ref.
              { s: { r: row.start, c: 7 }, e: { r: row.end, c: 7 } } //วันที่ซื้อ
            )
          })
          const dataWS = XLSX.utils.json_to_sheet(json)

          dataWS['!merges'] = merge
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, 'exportedReceiptData' + '.xlsx')
          this.loading = false
        }
      })
    },
    managerSave() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          rewardid_list: this.selectedItems,
          manager_status: 'approved' // approved หรือ reject
        }

        api.Managerapprovereceipttoacrm(data, async (err, response) => {
          if (response.responsecode == 200) {
            await this.$swal.fire({
              type: 'success',
              text: 'สำเร็จ'
            })
          }
          resolve()
        })
      })
    },
    accountingSave() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          rewardid_list: this.selectedItems,
          accounting_status: 'approved' // approved หรือ reject
        }

        api.Accountingapprovereceipttoacrm(data, async (err, response) => {
          if (response.responsecode == 200) {
            await this.$swal.fire({
              type: 'success',
              text: 'สำเร็จ'
            })
          }
          resolve()
        })
      })
    },
    onImport(item) {
      this.importloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        files: item[0]
      }
      api.toacrmimportbranch(data, async (err, response) => {
        this.importloading = false
        await this.$swal.fire({
          text: 'สำเร็จ',
          type: 'success'
        })
        this.getData()
      })
    },
    changePage(val) {
      // var vm = this
      // if (this.pagetmp == val) {
      //   //dont do shit
      // } else {
      //   this.pagetmp = val
      //   vm.offset = vm.pageNumber * this.limit - this.limit
      //   if (vm.pageNumber != 1) {
      //     vm.offset + 1
      //   }
      //   this.getBranch()
      // }
    },
    showAdminEdit(item) {
      this.editdata = item
      this.showEdit = true
    },
    onsave() {
      this.showEdit = false
      this.getData()
    },
    gotolink(link) {
      this.$nextTick(() => {
        window.location.href = link
      })
      // location.assign(this.qrlink)
    },
    showQrcode(item) {
      this.qrdialog = true
      this.qrdata = item
    },
    addBranch() {
      this.edittype = 'create'
      this.showEdit = true
    }
  }
}
</script>

<style lang="scss">
@import 'photoviewer/dist/photoviewer.css';
</style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/ApproveReceipt.vue